import { render } from "./articles.vue?vue&type=template&id=53b2b640"
import script from "./articles.vue?vue&type=script&lang=ts"
export * from "./articles.vue?vue&type=script&lang=ts"
script.render = render

export default script